import React, { useEffect, useState } from 'react'
import _ from 'lodash'
import FuelStationsOwnDataForm from './FuelStationsOwnDataForm'
import { validators } from '../../../utils/helpers/validators'
import FuelStationComparisionItem from './FuelStationComparisionItem'
import { SubTitle } from '../../common/form-components/label/Label'
import { FavoritesFuelStationsService } from '../../../services/favorites-fuel-stations/favoritesFuelStations.service'
import useInputs from '../../../utils/hooks/useInputs'
import SaveButton from '../../common/buttons/SaveButton'
import './fuelStationsOwnAdd.scss'

const FuelStationsOwnAdd = ({ handleCreate }) => {
  const { inputs, onChangeInputs } = useInputs({})
  const [favoriteStations, setFavoriteStations] = useState([])

  useEffect(() => {
    getFuelStationFavorite()
  }, [])

  const getFuelStationFavorite = async () => {
    const resp = await FavoritesFuelStationsService.getAll({})
    if (resp) {
      setFavoriteStations(resp?.resp)
    }
  }

  const createFuelStationOwn = () => {
    let data = {}

    if (!_.isEmpty(inputs?.comparisons)) {
      data = Object.fromEntries(
        Object.keys(inputs?.comparisons).map((comp) => [
          comp,
          {
            ...inputs?.comparisons[comp],
            favoriteStation: inputs?.comparisons[comp]?.favoriteStation?._id,
            difference: parseFloat(inputs?.comparisons[comp]?.difference),
          },
        ]),
      )
    }
    handleCreate({
      ...inputs,
      comparisons: data,
      minetur: { ...inputs?.minetur, id: parseInt(inputs?.minetur?.id, 10) },
    })
  }

  const validateForm =
    validators.hasValue(inputs?.label) &&
    validators.hasValue(inputs?.minetur?.id) &&
    (validators.hasValue(inputs?.center) ||
      validators.hasValue(inputs?.center?._id)) &&
    validators.hasValue(inputs?.minetur?.user) &&
    validators.hasValue(inputs?.minetur?.key) &&
    validators.hasValue(inputs?.minetur?.cins) &&
    validators.hasValue(inputs?.monolith)

  return (
    <div className="fuel-stations-own-add">
      <div className="fuel-stations-own-add__content modal-content-wrapper">
        {/* Datos generales de la estacion */}
        <FuelStationsOwnDataForm
          inputs={inputs}
          onHandleChange={onChangeInputs}
        />
        {/* Comparaciones */}
        <SubTitle id="fuelStation.comparision" />
        <FuelStationComparisionItem
          comparison="comparison1"
          inputs={inputs?.comparisons?.comparison1}
          favoriteStations={favoriteStations}
          onHandleChange={onChangeInputs}
        />
        <FuelStationComparisionItem
          comparison="comparison2"
          inputs={inputs?.comparisons?.comparison2}
          favoriteStations={favoriteStations}
          onHandleChange={onChangeInputs}
        />
        <FuelStationComparisionItem
          comparison="comparison3"
          inputs={inputs?.comparisons?.comparison3}
          favoriteStations={favoriteStations}
          onHandleChange={onChangeInputs}
        />
      </div>

      <div className="modal-btn-container">
        <SaveButton
          onClick={() => createFuelStationOwn()}
          isDisabled={!validateForm}
          btnClass="btn-save-modal"
        />
      </div>
    </div>
  )
}

export default FuelStationsOwnAdd
